import { render, staticRenderFns } from "./CartRequestedDelivery.vue?vue&type=template&id=51906681&"
import script from "./CartRequestedDelivery.vue?vue&type=script&lang=ts&"
export * from "./CartRequestedDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports